import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, Search, ShoppingBag, User } from 'lucide-react';
export const Navigation = () => {
  const links = ['THE MASK', 'BUILD', 'ARSENAL', 'BUNDLES', 'INTEL', 'CONTACT'];
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [visible, setVisible] = useState(true);
  const [cartCount] = useState(2);
  const lastScrollY = useRef(0);
  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      setScrolled(y > 20);
      // Always show at the very top
      if (y < 80) {
        setVisible(true);
      } else if (y > lastScrollY.current + 5) {
        // Scrolling down → hide
        setVisible(false);
        if (open) setOpen(false);
      } else if (y < lastScrollY.current - 5) {
        // Scrolling up → show
        setVisible(true);
      }
      lastScrollY.current = y;
    };
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, [open]);
  return <AnimatePresence data-id="element-410">
      {visible && <motion.nav initial={{
      y: -100
    }} animate={{
      y: 0
    }} exit={{
      y: -100
    }} transition={{
      duration: 0.3,
      ease: 'easeOut'
    }} className={`fixed top-[36px] w-full z-40 transition-[height,background,border,box-shadow] duration-300 ${scrolled ? 'h-[68px] bg-base-black/95 border-b border-acid-green/15 shadow-[0_4px_30px_rgba(0,0,0,0.6)]' : 'h-[84px] bg-base-black/80 border-b border-acid-green/5'} backdrop-blur-[20px] flex items-center justify-between px-4 md:px-10`} data-id="element-411">
          {/* Logo */}
          <a href="#" className="flex items-center group shrink-0" data-id="element-412">
            <img src="https://cdn.magicpatterns.com/uploads/gtew43sgjbWAUi8V7My12k/hf_20260505_154603_f5f185ee-8480-4693-8c47-91f27540bf0d.png" alt="Blackout Unit" className={`w-auto object-contain transition-all duration-300 group-hover:scale-105 ${scrolled ? 'h-12' : 'h-14 md:h-16'}`} data-id="element-413" />
          </a>

          {/* Desktop Links - centered */}
          <div className="hidden lg:flex items-center gap-10 font-barlow font-bold text-[11px] tracking-[3px] text-text-body absolute left-1/2 -translate-x-1/2" data-id="element-414">
            {links.map(link => <a key={link} href={`#${link.toLowerCase().replace(' ', '-')}`} className="hover:text-white transition-colors relative group py-2" data-id="element-415">
                {link}
                <span className="absolute -bottom-0.5 left-0 w-0 h-[1px] bg-acid-green group-hover:w-full transition-all duration-300" data-id="element-416"></span>
              </a>)}
          </div>

          {/* Right Actions */}
          <div className="flex items-center gap-1 sm:gap-2" data-id="element-417">
            <button aria-label="Search" className="hidden sm:flex w-10 h-10 items-center justify-center text-text-body hover:text-acid-green transition-colors" data-id="element-418">
              <Search size={18} strokeWidth={1.5} data-id="element-419" />
            </button>

            <button aria-label="Account" className="hidden sm:flex w-10 h-10 items-center justify-center text-text-body hover:text-acid-green transition-colors" data-id="element-420">
              <User size={18} strokeWidth={1.5} data-id="element-421" />
            </button>

            <button aria-label="Cart" className="relative w-10 h-10 flex items-center justify-center text-text-body hover:text-acid-green transition-colors group" data-id="element-422">
              <ShoppingBag size={20} strokeWidth={1.5} data-id="element-423" />
              {cartCount > 0 && <motion.span initial={{
            scale: 0
          }} animate={{
            scale: 1
          }} className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 bg-acid-green text-black font-barlow font-bold text-[10px] tracking-tighter rounded-full flex items-center justify-center group-hover:bg-white transition-colors" data-id="element-424">
                  {cartCount}
                </motion.span>}
            </button>

            <span className="hidden sm:block w-px h-6 bg-acid-green/15 mx-2" data-id="element-425"></span>

            <button className="hidden sm:block bg-acid-green text-black font-barlow font-bold text-[11px] tracking-[3px] px-5 py-3 clip-diagonal hover:bg-white transition-colors" data-id="element-426">
              DEPLOY NOW
            </button>

            <button onClick={() => setOpen(!open)} aria-label="Toggle menu" className="lg:hidden w-10 h-10 flex items-center justify-center text-acid-green ml-1" data-id="element-427">
              {open ? <X size={22} data-id="element-428" /> : <Menu size={22} data-id="element-429" />}
            </button>
          </div>

          {/* Mobile Drawer */}
          {open && <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="lg:hidden absolute top-full left-0 w-full bg-base-black/98 backdrop-blur-xl border-b border-acid-green/15 py-4 px-6 flex flex-col" data-id="element-430">
              {links.map(link => <a key={link} href={`#${link.toLowerCase().replace(' ', '-')}`} onClick={() => setOpen(false)} className="font-barlow font-bold text-sm tracking-[3px] text-text-body hover:text-acid-green transition-colors py-3 border-b border-dark-3" data-id="element-431">
                  {link}
                </a>)}
              <div className="flex items-center gap-3 mt-5" data-id="element-432">
                <button className="flex-1 flex items-center justify-center gap-2 border border-dark-3 text-text-body py-3 font-barlow font-bold text-xs tracking-[3px]" data-id="element-433">
                  <Search size={14} data-id="element-434" /> SEARCH
                </button>
                <button className="flex-1 flex items-center justify-center gap-2 border border-dark-3 text-text-body py-3 font-barlow font-bold text-xs tracking-[3px]" data-id="element-435">
                  <User size={14} data-id="element-436" /> ACCOUNT
                </button>
              </div>
              <button className="mt-4 bg-acid-green text-black font-barlow font-bold text-xs tracking-[3px] py-4 clip-diagonal w-full" data-id="element-437">
                DEPLOY NOW
              </button>
            </motion.div>}
        </motion.nav>}
    </AnimatePresence>;
};